"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APPROVE_SENDER_HEIGHT = void 0;
Object.defineProperty(exports, "BlockPrompt", {
  enumerable: true,
  get: function get() {
    return _Prompt["default"];
  }
});
Object.defineProperty(exports, "CardAction", {
  enumerable: true,
  get: function get() {
    return _SenderCard.CardAction;
  }
});
Object.defineProperty(exports, "SenderCard", {
  enumerable: true,
  get: function get() {
    return _SenderCard["default"];
  }
});
Object.defineProperty(exports, "SenderList", {
  enumerable: true,
  get: function get() {
    return _SenderList["default"];
  }
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _SenderCard = _interopRequireWildcard(require("./SenderCard"));
var _SenderList = _interopRequireDefault(require("./SenderList"));
var _Prompt = _interopRequireDefault(require("./Prompt"));
var _excluded = ["children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var APPROVE_SENDER_HEIGHT = exports.APPROVE_SENDER_HEIGHT = 160;
var _default = exports["default"] = function _default(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "mx-4 bg-none",
    style: {
      height: APPROVE_SENDER_HEIGHT
    }
  }), children);
};
//# sourceMappingURL=index.js.map